import { Component, OnInit, Input } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  UntypedFormBuilder,
} from "@angular/forms";
import { Router } from "@angular/router";
import { DaoService } from "./../../services/dao.service";
import { LstorageService } from "./../../services/lstorage.service";
import { ReplaySubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

interface Bank {}

@Component({
  selector: "app-api-mapping",
  templateUrl: "./api-mapping.component.html",
  styleUrls: ["./api-mapping.component.scss"],
})
export class ApiMappingComponent implements OnInit {
  //Filter begin
  @Input() placeholderLabel = "Search";
  @Input() noEntriesFoundLabel = "No result found";
  get value(): string {
    return this._value;
  }
  private _value: string;
  //Filter End

  apiStaticAttribue: any;
  apiDynamicAttribue: any = [];
  apiMappedAttribute: any;
  apiMappingId: any;
  apiData: any;
  apiResponseData: any;

  groupId: any;
  parentId: any;
  apiId: any;
  sourceName: any;

  //Form Object
  apiMapping = new FormGroup({
    apiStatic: new FormControl(),
  });

  public Shown = {
    beforeFilter: true,
    afterFilter: false,
  };

  //Search filter
  public banks: Bank[] = this.apiDynamicAttribue;
  public DynamicAttribueMultiFilterCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();
  public filteredDynamicAttribueMulti: ReplaySubject<Bank[]> =
    new ReplaySubject<Bank[]>(1);
  public search: string;

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private daoService: DaoService,
    private token: LstorageService
  ) {
    if (this.token.getToken() == null) {
      this.router.navigate(["/login"]);
    }
    this.apiStaticAttribue = this.token.getApiStaticData();
    this.apiResponseData = this.token.getApiResponse();

    console.log("Api Static Attribute");
    console.log(this.apiStaticAttribue);
    this.apiDynamicAttribue = this.token.getApiDyanamicAttribute();
    console.log("Api Dynamic Attribute");
    console.log(this.apiDynamicAttribue);

    this.apiData = this.token.getApiData();
    this.apiMappedAttribute = this.token.getApiMappingData();

    console.log("Api Mapped Attribute");
    console.log(this.apiMappedAttribute);
  }

  ngOnInit() {
    if (this.apiMappedAttribute) {
      this.apiMappingId = this.token.getApiMappingId();

      var firstValueunmatched = true;
      for (var k = 0; k < this.apiMappedAttribute.length; k++) {
        if (
          this.apiStaticAttribue[0].AttributeId ===
          this.apiMappedAttribute[k].Attribute
        ) {
          this.apiMapping = this.formBuilder.group({
            apiStatic: this.formBuilder.array([
              this.dynamicForm(
                this.apiStaticAttribue[0].Name,
                this.apiStaticAttribue[0].AttributeId,
                this.apiMappedAttribute[k].AttributeMap
              ),
            ]),
          });
          firstValueunmatched = false;
          break;
        }
      }

      if (firstValueunmatched) {
        this.apiMapping = this.formBuilder.group({
          apiStatic: this.formBuilder.array([
            this.dynamicForm(
              this.apiStaticAttribue[0].Name,
              this.apiStaticAttribue[0].AttributeId,
              null
            ),
          ]),
        });
      }
      //==========

      for (var i = 1; i < this.apiStaticAttribue.length; i++) {
        if (!this.apiMappedAttribute[i]) {
          // this.addForm(this.apiStaticAttribue[i].Name, this.apiStaticAttribue[i].AttributeId, null);
        }

        var unmatched = true;
        for (var j = 0; j < this.apiMappedAttribute.length; j++) {
          if (
            this.apiStaticAttribue[i].AttributeId ===
            this.apiMappedAttribute[j].Attribute
          ) {
            //alert(this.apiStaticAttribue[i].AttributeId===this.apiMappedAttribute[i].Attribute);
            this.addForm(
              this.apiStaticAttribue[i].Name,
              this.apiStaticAttribue[i].AttributeId,
              this.apiMappedAttribute[j].AttributeMap
            );
            unmatched = false;
            break;
          }
        }

        if (unmatched) {
          this.addForm(
            this.apiStaticAttribue[i].Name,
            this.apiStaticAttribue[i].AttributeId,
            null
          );
        }
      }
    } else {
      this.apiMappingId = null;
      this.apiMapping = this.formBuilder.group({
        apiStatic: this.formBuilder.array([
          this.dynamicForm(
            this.apiStaticAttribue[0].Name,
            this.apiStaticAttribue[0].AttributeId,
            null
          ),
        ]),
      });

      for (var i = 1; i < this.apiStaticAttribue.length; i++) {
        this.addForm(
          this.apiStaticAttribue[i].Name,
          this.apiStaticAttribue[i].AttributeId,
          null
        );
      }
    }

    //Filter on change
    this.filteredDynamicAttribueMulti.next(this.apiDynamicAttribue.slice());
    this.DynamicAttribueMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDynamicAttribueMulti();
      });
  }

  private dynamicForm(formName, id, MappedValue) {
    return this.formBuilder.group({
      attributeName: [formName],
      attribute: [id],
      attributeMap: [MappedValue],
    });
  }

  addForm(formName, id, MappedValue) {
    // const control = <FormArray>this.apiMapping.controls["apiStatic"];
    const control = this.apiMapping.get("apiStatic") as FormArray;
    control.push(this.dynamicForm(formName, id, MappedValue));
  }
  //Dynamic Form End
  //Add Mapping
  apiMappingSubmit() {
    var mappingAttribute = {
      attribute: this.apiMapping.value.apiStatic.attribute,
      attributeMap: this.apiMapping.value.apiStatic.attributeMap,
    };

    var apiManagerMapping = {
      apiManager: this.apiData,
      apiManagerMapping: {
        apiMappingId: this.apiMappingId,
        apiId: this.apiData.ApiId,
        mappingAttributes: this.apiMapping.value.apiStatic,
        isActive: true,
        createdBy: "string",
        createdOn: "2019-09-25T06:39:20.849Z",
        modifiedBy: "string",
        modifiedOn: "2019-09-25T06:39:20.849Z",
      },
    };
    this.daoService
      .apiManagerMapping(apiManagerMapping)
      .subscribe((data: any) => {
        console.log("Api manager data");
        console.log(data);

        if (data.isSuccess) {
          this.groupId = this.token.getGroupId();
          this.parentId = this.token.getParentId();
          this.sourceName = data.data.ApiManagerData.SourceName;
          this.apiId = data.data.ApiManagerData.ApiId;

          var apigroup = {
            GroupId: this.groupId,
            SourceName: this.sourceName,
            ApiId: this.apiId,
            ParentID: this.parentId,
            IsActive: true,
            CreatedBy: "",
            createdOn: "2020-01-21T11:35:46.062Z",
            ModifiedBy: "",
            modifiedOn: "2020-01-21T11:35:46.062Z",
          };
          console.log("Api Group");
          console.log(apigroup);

          this.daoService.addApiGroup(apigroup).subscribe((datas: any) => {
            console.log("Apigroup data");
            console.log(datas);
            this.token.saveGroupId(datas.data.groupId);
          });
          this.router.navigate(["/responseMapping"]);
        }
      });
  }

  //Filter
  public filterDynamicAttribueMulti() {
    if (!this.apiDynamicAttribue) {
      return;
    }

    // get the search keyw
    this.search = this.DynamicAttribueMultiFilterCtrl.value;

    if (!this.search) {
      this.filteredDynamicAttribueMulti.next(this.apiDynamicAttribue.slice());
      return;
    } else {
      this.search = this.search.toLowerCase();
    }
    console.log("serarsch ids");
    this.filteredDynamicAttribueMulti.next(
      this.apiDynamicAttribue.filter(
        (apiDynamicAttribue) =>
          apiDynamicAttribue.toLowerCase().indexOf(this.search) > -1
      )
    );
  }

  public clearFilter(i) {
    console.log("search filed value");
    console.log(this.DynamicAttribueMultiFilterCtrl.value);
    this.DynamicAttribueMultiFilterCtrl.reset();
    this.search = "";
    this.filteredDynamicAttribueMulti.next(
      this.apiDynamicAttribue.filter(
        (apiDynamicAttribue) =>
          apiDynamicAttribue.toLowerCase().indexOf(this.search) > -1
      )
    );
  }
}
